import { useRef } from "react";
import { Flex, Paper, Header3, PrimaryButton } from "@base-ui";
import { ColorSelect } from "./selectColorDialog.styles";
import { closePopup, blockDefaultEvent } from "utils/events";
import { customizableColors, defaultColor } from "utils/colors";
import { useLockedFocusArea } from "hooks";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function SelectColorDialog(_ref) {
  var selectColor = _ref.selectColor,
    prevId = _ref.prevId;
  var containerRef = useRef();
  var firstRef = useRef();
  var lastRef = useRef();
  useLockedFocusArea(containerRef, firstRef, lastRef);
  var handleCancel = function handleCancel(e) {
    blockDefaultEvent(e);
    closePopup();
  };
  var handleConfirmColor = function handleConfirmColor(color) {
    closePopup();
    selectColor(color);
    document.getElementById(prevId).focus();
  };
  var colorsMarkup = [defaultColor].concat(customizableColors).map(function (color, idx) {
    return /*#__PURE__*/_jsx(ColorSelect, {
      id: "select-color-".concat(idx),
      color: color.hex,
      ref: idx === 0 ? firstRef : undefined,
      onClick: function onClick() {
        return handleConfirmColor(color.hex);
      }
    }, color.hex);
  });
  return /*#__PURE__*/_jsxs(Paper.Column, {
    maxWidth: "400px",
    ref: containerRef,
    children: [/*#__PURE__*/_jsx(Header3, {
      inverted: true,
      m: "0",
      p: "15px 20px",
      backgroundColor: "P3",
      children: "V\xE4lj en f\xE4rg"
    }), /*#__PURE__*/_jsxs(Flex.Column, {
      p: "sm",
      children: [/*#__PURE__*/_jsx(Flex.Row, {
        flexWrap: "wrap",
        mb: "20px",
        children: colorsMarkup
      }), /*#__PURE__*/_jsx(Flex.Row, {
        justifyContent: "flex-end",
        children: /*#__PURE__*/_jsx(PrimaryButton, {
          width: "130px",
          id: "leave-popup",
          ref: lastRef,
          onClick: handleCancel,
          children: "Avbryt"
        })
      })]
    })]
  });
}